<app-reset-password
	[requesting]="requesting"
	(formEmitter)="handleResetPassword($event)"
></app-reset-password>
